import { useEffect } from "react";
import { Controller } from "react-hook-form";
import type { PathArray } from "common/utils/formStructure";
import { Number } from "../../../../../../../Inputs";
import {
  getSchemaPropertyFormPath,
  getUiSchemaPropertyFormPath,
  useBuilderFormContext,
  useBuilderWatch,
} from "../../../form/form";

type NumberStaticDefaultInputProps = {
  fieldPath: PathArray;
  isReadOnly: boolean;
};

export function NumberStaticDefaultInput({
  fieldPath,
  isReadOnly,
}: NumberStaticDefaultInputProps) {
  const { control, trigger } = useBuilderFormContext();

  const defaultValuePropertyFormPath = getUiSchemaPropertyFormPath(
    fieldPath,
    "defaultValue",
  );
  const minimumValuePropertyFormPath = getSchemaPropertyFormPath(
    fieldPath,
    "minimum",
  );
  const maximumValuePropertyFormPath = getSchemaPropertyFormPath(
    fieldPath,
    "maximum",
  );

  const minimumValue = useBuilderWatch(minimumValuePropertyFormPath);
  const maximumValue = useBuilderWatch(maximumValuePropertyFormPath);
  const defaultValue = useBuilderWatch(defaultValuePropertyFormPath);

  useEffect(() => {
    void trigger(defaultValuePropertyFormPath);
  }, [minimumValue, maximumValue, trigger, defaultValuePropertyFormPath]);

  return (
    <Controller
      control={control}
      name={defaultValuePropertyFormPath}
      render={({ field, fieldState }) => {
        return (
          <Number
            name={field.name}
            label="Static default value"
            value={defaultValue}
            onChange={value => {
              // store no value (undefined) for ui:defaultValue instead of null
              // in form state
              field.onChange(value ?? undefined);
            }}
            disabled={isReadOnly}
            readonly={isReadOnly}
            error={fieldState.error?.message}
          />
        );
      }}
    />
  );
}
